export enum LoginRequired {
  Always = 'always',
  SRRequiredOnly = 'srRequiredOnly',
  Never = 'never',
}
